import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { RouteService } from './route.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationVisibilityService {
  constructor(
    private readonly authService: AuthService,
    private readonly route: RouteService
  ) {}

  /**
   * Check if navigation should be hidden based on user's role for current application
   * @return true if current application role has HideNavigationContainer set to true
   */
  shouldHideNavForRole(): boolean {
    try {
      const appKey = this.route.getApplicationKey();
      if (!appKey || !this.authService.userProfile?.ApplicationRoles) {
        return false;
      }

      const appRole = this.authService.userProfile.ApplicationRoles.find(
        (role: any) => role.ApplicationKey === appKey
      );

      return appRole?.HideNavigationContainer === true;
    } catch {
      return false;
    }
  }
}

